import React, {useContext, useEffect, useState} from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Draggable from 'react-draggable';
import Paper from '@mui/material/Paper';
import { AuthContext } from '../../../contexts/authContext';
import config from '../../../config';
import axios from 'axios';
import { TextField, Divider } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import {v4 as uuidv4} from 'uuid';
import useNotification from '../../../hooks/useNotification';
import { TimeField } from '@mui/x-date-pickers/TimeField';

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
        <Draggable
            nodeRef={nodeRef}
            handle="#draggable-dialog-title"
            cancel={'[class*="MuiDialogContent-root"]'}
        >
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}

function ManageTickersDialog(props) {
    const auth = useContext(AuthContext);
    const { notificationSuccess, notificationError } = useNotification();
    const [idEntita, setIdEntita] = useState('');
    const [city, setCity] = useState('');
    const [titolo, setTitolo] = useState('');
    const [itdescription, setItdescription] = useState('');
    const [endescription, setEndescription] = useState('');

    const [beginDate, setBeginDate] = useState(moment());
    const [expireDate, setExpireDate] = useState(null);

    const [startTime, setStartTime] = useState(moment().set({ hour: 0, minute: 0, second: 0 }));
    const [endTime, setEndTime] = useState(moment().set({ hour: 23, minute: 59, second: 0 }));

    const [originalTitolo, setOriginalTitolo] = useState('');
    const [originalItdescription, setOriginalItdescription] = useState('');
    const [originalEndescription, setOriginalEndescription] = useState('');
    const [originalBeginDate, setOriginalBeginDate] = useState(moment());
    const [originalExpireDate, setOriginalExpireDate] = useState(null);

    const [originalStartTime, setOriginalStartTime] = useState(moment().set({ hour: 0, minute: 0, second: 0 }));
    const [originalEndTime, setOriginalEndTime] = useState(moment().set({ hour: 23, minute: 59, second: 0 }));

    const [errorControlDates, setErrorControlDates] = useState(null);
    const [errorControlTime, setErrorControlTime] = useState(null);

    useEffect(() => {
        async function init(){
            if(props.openManageTickersDialog==='mod'){
                setIdEntita(props.lastCellData?.idEntita.S);
                setCity(props.lastCellData?.city.S);
                setTitolo(props.lastCellData?.titolo.S);
                setItdescription(props.lastCellData?.itdescription.S);
                setEndescription(props.lastCellData?.endescription.S);
                setBeginDate(props?.lastCellData?.beginDate?.S ? moment(props?.lastCellData?.beginDate?.S, 'YYYYMMDD') : moment());
                setExpireDate(props?.lastCellData?.expireDate.S ? moment(props?.lastCellData?.expireDate.S, 'YYYYMMDD') : null);
                setStartTime(props?.lastCellData?.startTime?.S ? moment(props?.lastCellData?.startTime.S, 'HHmm') : moment().set({ hour: 0, minute: 0, second: 0 }))
                setEndTime(props?.lastCellData?.endTime?.S ? moment(props?.lastCellData?.endTime.S, 'HHmm') : moment().set({ hour: 23, minute: 59, second: 0 }))

                setOriginalTitolo(props.lastCellData?.titolo.S);
                setOriginalItdescription(props.lastCellData?.itdescription.S);
                setOriginalEndescription(props.lastCellData?.endescription.S);
                setOriginalBeginDate(props?.lastCellData?.beginDate?.S || moment());
                setOriginalExpireDate(props.lastCellData?.expireDate.S || null);
                setOriginalStartTime(props?.lastCellData?.startTime?.S || moment().set({ hour: 0, minute: 0, second: 0 }))
                setOriginalEndTime(props?.lastCellData?.endTime?.S || moment().set({ hour: 23, minute: 59, second: 0 }))
            }else{
                setIdEntita('');
                setCity('');
                setTitolo('');
                setItdescription('');
                setEndescription('');
                setBeginDate(moment());
                setExpireDate(null);
                setStartTime(moment().set({ hour: 0, minute: 0, second: 0 }));
                setEndTime(moment().set({ hour: 23, minute: 59, second: 0 }));
            }
        }
        init()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[props.openManageTickersDialog])

    const insTicker = async() => {
        try {
            const data = {
                idEntita: uuidv4(),
                titolo: titolo,
                itdescription: itdescription,
                endescription: endescription,
                beginDate: beginDate.format('YYYYMMDD'),
                expireDate: expireDate.format('YYYYMMDD'),
                startTime: startTime.format('HHmm'),
                endTime: endTime.format('HHmm'),
                city: props.city
            }

            const axiosParams = {
                url: '/ins-ticker',
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data
            };

            await axios(axiosParams);
            notificationSuccess('Ticker Aggiunto');

            await props.getTickers();
            props.handleCloseManageTickersDialog();
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response?.data?.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    const modTicker = async() => {
        try {
            const data = {
                titolo: titolo === originalTitolo ? '' : titolo,
                itdescription: itdescription === originalItdescription ? '' : itdescription,
                endescription: endescription === originalEndescription ? '' : endescription,
                beginDate: beginDate.format('YYYYMMDD') === originalBeginDate ? '' : beginDate.format('YYYYMMDD'),
                expireDate: expireDate.format('YYYYMMDD') === originalExpireDate ? '' : expireDate.format('YYYYMMDD'),
                startTime: startTime.format('HHmm') === originalStartTime ? '' : startTime.format('HHmm'),
                endTime: endTime.format('HHmm') === originalEndTime ? '' : endTime.format('HHmm')
            }
            
            const dataToPass = {
                idEntita: idEntita,
                city: city,
                ExpressionAttributeNames: {},
                ExpressionAttributeValues: {},
                UpdateExpression: "SET",
            };
            
            let dataKeys = Object.keys(data);
            for (let index = 0; index < dataKeys.length; index++) {
                const element = dataKeys[index];
                
                if(!data[element]){
                    delete data[element];
                }else{
                    dataToPass.ExpressionAttributeNames['#'+element] = element
                    dataToPass.ExpressionAttributeValues[':'+element] = {"S": data[element]};
                    dataToPass.UpdateExpression = `${dataToPass.UpdateExpression} #${element}=:${element},`;
                }
            }

            if(!Object.keys(data).length){
                //se non ci sono chiavi non è cambiato nulla e ritorno
                return;
            }

            const axiosParams = {
                url: '/mod-ticker',
                method: 'post',
                baseURL: config.API_URL,
                headers: { 
                    Authorization: `Bearer ${auth.sessionInfo?.accessToken}` 
                },
                data: dataToPass
            };

            const response = await axios(axiosParams);
            notificationSuccess('Ticker Aggiornato');

            let newOriginalItems = response.data.responseUpdate.Attributes

            setOriginalTitolo(newOriginalItems?.titolo.S || '');
            setOriginalItdescription(newOriginalItems?.itdescription.S || '');
            setOriginalEndescription(newOriginalItems?.endescription.S || '');
            setOriginalBeginDate(newOriginalItems?.beginDate.S || moment());
            setOriginalExpireDate(newOriginalItems?.expireDate.S || null);

            setOriginalStartTime(newOriginalItems?.startTime.S || moment().set({ hour: 0, minute: 0, second: 0 })); 
            setOriginalEndTime(newOriginalItems?.endTime.S || moment().set({ hour: 23, minute: 59, second: 0 }))

            await props.getTickers();
            props.handleCloseManageTickersDialog();
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logOut();
            } else {
                if (typeof error.response.data.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
        }
    }

    return (
        <Dialog className="dialog-mod-ticker" open={props.openManageTickersDialog} onClose={props.handleCloseManageTickersDialog} PaperComponent={PaperComponent} >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">{props.openManageTickersDialog === 'ins' ? 'Inserisci ticker' : props?.lastCellData?.titolo?.S}</DialogTitle>
            <DialogContent>
                <div className='dialog-ticker-wrapper'>
                    <div className='dialog-ticker-wrapper-section'>
                        <div className="dialog-ticker-fields">
                            <TextField
                                className="dialog-titolo required-field-bg"
                                id="dialog-titolo"
                                label="Titolo"
                                type="text"
                                value={titolo}
                                onChange={(event) => {
                                    setTitolo(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%"
                                }}
                            />
                            <TextField
                                className="dialog-itdescription required-field-bg"
                                id="dialog-itdescription"
                                label="Descrizione-IT"
                                type="text"
                                value={itdescription}
                                onChange={(event) => {
                                    setItdescription(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%"
                                }}
                            />
                            <TextField
                                className="dialog-endescription required-field-bg"
                                id="dialog-endescription"
                                label="Descrizione-EN"
                                type="text"
                                value={endescription}
                                onChange={(event) => {
                                    setEndescription(event.target.value);
                                }}
                                variant="standard"
                                style={{
                                    width: "100%"
                                }}
                            />
                        </div>
                    </div>
                    
                        <Divider variant="middle"/>
                    <div className='dialog-ticker-wrapper-fields'>
                        <div className="dialog-ticker-fields">
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    className='dialog-begin-date'
                                    label="Data di inizio"
                                    value={beginDate}
                                    onChange={(newValue) => {setBeginDate(newValue); if(expireDate.isBefore(newValue))setExpireDate(newValue)}}
                                    format="DD/MM/YYYY"
                                    slotProps={{
                                        textField: {
                                            variant: "standard",
                                            className: "required-field-bg",
                                            style:{
                                                width: "100%",
                                                maxWidth: "150px"
                                            }
                                        }
                                    }}
                                    disablePast
                                />
                                
                                <DatePicker
                                    className='dialog-expire-date'
                                    label="Data di scadenza"
                                    value={expireDate}
                                    onChange={(newValue) => setExpireDate(newValue)}
                                    format="DD/MM/YYYY"
                                    minDate={beginDate}
                                    onError={(error) => setErrorControlDates(error)}
                                    slotProps={{
                                        textField: {
                                            variant: "standard",
                                            className: "required-field-bg",
                                            style:{
                                                width: "100%",
                                                maxWidth: "150px"
                                            }
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="dialog-ticker-fields">
                            <LocalizationProvider dateAdapter={AdapterMoment}>    
                                <TimeField
                                    className='dialog-start-time'
                                    label="Recuperato dalle" 
                                    value={startTime}
                                    onChange={(newValue) => {setStartTime(newValue); if(endTime.isBefore(newValue))setEndTime(newValue)}}
                                    ampm={false}
                                    slotProps={{
                                        textField: {
                                            variant: "standard",
                                            className: "required-field-bg",
                                            style:{
                                                width: "100%",
                                                maxWidth: "150px"
                                            }
                                        }
                                    }}
                                />
                                <TimeField
                                    className='dialog-end-time'
                                    label="Fino alle" 
                                    value={endTime} 
                                    onChange={(newValue) => setEndTime(newValue)}
                                    onError={(error) => setErrorControlTime(error)}
                                    ampm={false}
                                    minTime={startTime}
                                    slotProps={{
                                        textField: {
                                            variant: "standard",
                                            className: "required-field-bg",
                                            style:{
                                                width: "100%",
                                                maxWidth: "150px"
                                            }
                                        }
                                    }}
                                />
                            </LocalizationProvider>
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button variant="standard" onClick={() => props.openManageTickersDialog === 'ins' ? insTicker() : modTicker()} disabled={(errorControlDates || errorControlTime || !expireDate || !beginDate || !startTime || !endTime)}>
                    Salva
                </Button>
                <Button variant="outlined" autoFocus onClick={props.handleCloseManageTickersDialog}>
                    Esci
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ManageTickersDialog